import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[headerTemplate]',
    standalone: false
})
export class HeaderTemplateDirective {
  public readonly viewContainerRef = inject(ViewContainerRef);
}
